import type { Attachment, Message } from "../types";

export function formatDate(value?: string | null) {
  if (!value) return "无";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
}

export function toIso(value: string) {
  return new Date(value).toISOString();
}

export function toLocalInput(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function typeLabel(type?: string | null) {
  const map: Record<string, string> = {
    record: "记录",
    todo: "待办",
    reminder: "提醒",
    schedule: "日程",
    idea: "想法",
    resource: "资料",
    checklist: "清单",
    project: "项目",
    person: "人物",
    journal: "日志"
  };
  return type ? map[type] || type : "未分类";
}

export function statusLabel(status: string) {
  const map: Record<string, string> = {
    unprocessed: "未处理",
    processed: "已处理",
    pending_confirmation: "待确认",
    archived: "已归档",
    ignored: "已忽略",
    converted_todo: "已转待办",
    converted_reminder: "已转提醒",
    converted_schedule: "已转日程",
    deleted: "已删除"
  };
  return map[status] || status;
}

export function readableError(error: unknown) {
  return error instanceof Error ? error.message : String(error);
}

export function formatBytes(value?: number | null) {
  const bytes = Number(value || 0);
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB`;
}

export function messageDisplayText(message: Message, attachments: Attachment[] = []) {
  const content = message.content.trim();
  if (content) return content;

  const ids = message.attachment_ids || [];
  const firstAttachment = ids
    .map((id) => attachments.find((attachment) => attachment.id === id))
    .find((attachment): attachment is Attachment => Boolean(attachment));
  if (!firstAttachment) {
    return ids.length ? `附件记录 · ${ids.length} 个文件` : "空白记录";
  }
  return ids.length === 1
    ? `附件记录 · ${firstAttachment.filename}`
    : `附件记录 · ${firstAttachment.filename} 等 ${ids.length} 个文件`;
}
